import gql from 'graphql-tag'

export const queryUser = gql`
	query {
		user {
			id
			accountPaid
			email
			nameFirst
			nameLast
			birthDate
			birthPlace
			birthSigns
			birthTime
			lookup
		}
	}
`



// WEBPACK FOOTER //
// ./src/graphql/queries/user.js